import { LOAD_VEHICLES_COMPLETE, RESET } from '../../actions/vehicle.actions';
import { Vehicle } from '@cemex-core/cmx-api/models/vehicles/model/vehicle';
import { VehiclesActions } from '../../actions/vehicle.actions';

export interface VehicleState {
  vehicles: Vehicle[];
}

export const initialState: VehicleState = {
  vehicles: [],
};

export function vehicleReducer(state = initialState, action: VehiclesActions): VehicleState {
  switch (action.type) {
    case LOAD_VEHICLES_COMPLETE: {
      return {
        ...state,
        vehicles: action.payload,
      } as VehicleState;
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
